//Default NoteTemplateSection to initialize editable items when creating a new entity in the editor
//Frozen so this default can't be changed by users.
export const default_NoteTemplateSection = Object.freeze({
    subSections: [],
    isIndented: false,
    isEditable: true,
    isSelectable: true,
    defaultSelected: true,
    dispositionSection: false,
});
//# sourceMappingURL=consts.js.map